import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
import {BaseModal} from '../../../../model/base';

declare var app;

@Component({
  selector: 'app-sfa-list-products',
  templateUrl: './sfa-list-products.component.html',
  styleUrls: ['./sfa-list-products.component.scss']
})
export class SfaListProductsComponent extends GridBaseCase {

  
  searchDate = null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
 
  RecordCount: Number = 0;//列表总数量

  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super(); }


  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  searchChange($event,type:any="other"){
    if($event.keyCode == 13 || type == 'search'){
      this.LoadData(1);
    }
  }
  confirmEvent(){

  }
  LoadData(PageNumber) {
    const that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }

    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body: WebParameterContext = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.Account = that.com.GetAccount;
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.Name = pageName;
    body.Client.PageName = pageName;
    // if (that.platform.is("android")) {
    //   body.Client.ClientType = 0;
    // } else if (that.platform.is("ios")) {
    //   body.Client.ClientType = 1;
    // }
    // body.RequestBody = JSON.stringify({ 'a_ID': id });
    if (that.searchDate) {
      body.RequestBody = JSON.stringify({ "a_ProductName": that.com.LikeSearch(that.searchDate)});
    }
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
       
          //判断选中的值
          let tempoCheckList:Array<any>=[];
          that.base.GridArrayData.forEach(item=>{
             if(!item.id){
              tempoCheckList.push(item);
             }
          });
        data.Status.Datas.forEach(function (item) {
          tempoCheckList.forEach(itemcheck=>{//选中数据
            if(item.a_Code==itemcheck.code.value){
              item.isCheck=true;
            }
          });
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
          
            if (element.bindingField) {
              objfield[element.bindingField] = item[element.field];
            }
            if (element.bindingField == 'date' && item[element.field]) {
              objfield[element.bindingField] = item[element.field].replace('00:00:00', '');
            }
          });
          objfield["isCheck"]=item.isCheck;
          that.dataArrayList.push(objfield);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      } else {
        console.log(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      that.loading = true;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;

      console.log(error);
    })
  }

  EventLink(ev: any, parms: any,index) {
    let that =this;
    parms['isCheck'] = !parms['isCheck'];
    if(parms['isCheck']){
      
    if(!that.baseService.gridSearchDate.find((data)=>data.id==parms.id)){
      that.baseService.gridSearchDate.push(parms);
    }
    }else{
      that.baseService.gridSearchDate.splice(index,1)
    }
    // that.collectionAppeal.SeacherData(that.baseService.gridSearchDate);
    // console.log(that.baseService.gridSearchDate);
  }

}
